import React from 'react';
import './App.css';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import GamesShowcase from './components/GamesShowcase';
import BlueprintOfGrowth from './components/BlueprintOfGrowth';
import LegalDocumentation from './components/LegalDocumentation';
import Contacts from './components/Contacts';

function App() {
  return (
    <div className="App">
      <Navigation />
      
      <main className="App-main">
        <HeroSection />
        <GamesShowcase />
        <BlueprintOfGrowth />
        <LegalDocumentation />
        <Contacts />
      </main>
      
      <footer className="App-footer">
        <p>&copy; {new Date().getFullYear()} BG5 LLC. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;

